// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ace-editor.ace_editor *[data-v-05db67d0] {\n  font-family: 'VL Gothic for AceEditor', Monaco, Menlo, 'Ubuntu Mono', Consolas, source-code-pro, monospace !important;\n}\n", ""]);
// Exports
module.exports = exports;
